package ru.dinarastepina.fabvocab.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import ru.dinarastepina.fabvocab.web.api.VocabularyApiClient
import ru.dinarastepina.fabvocab.web.components.FeedbackCard
import ru.dinarastepina.fabvocab.web.components.TopBar
import ru.dinarastepina.fabvocab.web.theme.Indigo600
import ru.dinarastepina.fabvocab.web.theme.IndigoPalette
import ru.dinarastepina.fabvocab.web.theme.Slate500
import ru.dinarastepina.fabvocab.web.theme.SlatePalette

@Page("login")
@Composable
fun LoginPage() {
    val ctx = rememberPageContext()
    val scope = rememberCoroutineScope()
    val client = remember { VocabularyApiClient() }
    val username = remember { mutableStateOf("") }
    val password = remember { mutableStateOf("") }
    val isRegister = remember { mutableStateOf(false) }
    val loading = remember { mutableStateOf(false) }
    val error = remember { mutableStateOf<String?>(null) }

    Column(modifier = Modifier.fillMaxWidth().gap(16.px)) {
        TopBar(
            title = if (isRegister.value) "Sign Up" else "Sign In",
            navigation = {
                Button(
                    onClick = { ctx.router.navigateTo("/") },
                    colorPalette = SlatePalette,
                    size = ButtonSize.XS,
                    modifier = Modifier.margin(right = 8.px),
                ) {
                    SpanText("\u2190 Back")
                }
            },
        )

        Column(
            modifier = Modifier.fillMaxWidth().gap(12.px),
        ) {
            SpanText(
                if (isRegister.value) "Create account" else "Welcome back",
                modifier = Modifier.fontSize(20.px).fontWeight(FontWeight.Bold),
            )

            TextInput(
                text = username.value,
                onTextChange = { username.value = it },
                modifier = Modifier.fillMaxWidth(),
                placeholder = "Username",
            )

            TextInput(
                text = password.value,
                onTextChange = { password.value = it },
                modifier = Modifier.fillMaxWidth(),
                placeholder = "Password",
            )

            error.value?.let {
                FeedbackCard(message = it, isError = true)
            }

            Button(
                onClick = {
                    scope.launch {
                        loading.value = true
                        error.value = null
                        try {
                            if (isRegister.value) {
                                client.register(username.value.trim(), password.value)
                            } else {
                                client.login(username.value.trim(), password.value)
                            }
                            ctx.router.navigateTo("/")
                        } catch (e: Exception) {
                            error.value = e.message
                        } finally {
                            loading.value = false
                        }
                    }
                },
                enabled = !loading.value && username.value.isNotBlank() && password.value.length >= 4,
                colorPalette = IndigoPalette,
                size = ButtonSize.SM,
            ) {
                SpanText(
                    if (loading.value) "Please wait..." else if (isRegister.value) "Sign Up" else "Sign In",
                    modifier = Modifier.fontWeight(FontWeight.Bold),
                )
            }

            Box(
                modifier = Modifier.margin(top = 8.px),
                contentAlignment = Alignment.Center,
            ) {
                Button(
                    onClick = { isRegister.value = !isRegister.value; error.value = null },
                    colorPalette = SlatePalette,
                    size = ButtonSize.XS,
                ) {
                    SpanText(
                        if (isRegister.value) "Already have an account? Sign In"
                        else "Don't have an account? Sign Up",
                        modifier = Modifier.fontSize(12.px).color(Slate500),
                    )
                }
            }
        }
    }
}
